<template>
  <div class="upload-file" v-loading="loading">
    <el-upload
      :action="uploadFileUrl"
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :show-file-list="false"
      :headers="headers"
      class="upload-file-uploader"
      ref="upload"
      :data="uploadData"
      multiple
      v-if="!disabled"
    >
      <!-- 上传按钮 -->
      <el-button size="mini" type="primary" v-if="!disabled">{{ btnText }}</el-button>
      <!-- 上传提示 -->
      <div class="el-upload__tip" slot="tip" v-if="showTip && !disabled">
        请上传
        <template v-if="fileSize">
          大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
        </template>
        <template v-if="fileType">
          格式为 <b style="color: #f56c6c">{{ fileType.join('/') }}</b>
        </template>
        的文件
      </div>
    </el-upload>

    <!-- 文件列表 -->
    <div v-if="fileList.length || !disabled">
      <transition-group class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul">
        <li
          :key="file.uid"
          class="el-upload-list__item ele-upload-list__item-content"
          v-if="!(file.type == 'jpg' || file.type == 'png' || file.type == 'jpeg')"
          v-for="(file, index) in fileList"
        >
          <el-link :href="`${file.url}`" :underline="false" target="_blank">
            <span class="el-icon-document"> {{ getFileName(file.name) }} </span>
          </el-link>
          <div class="ele-upload-list__item-content-action">
            <el-link :underline="false" @click="handleDelete(index)" type="danger" v-if="!disabled">删除</el-link>
          </div>
        </li>
      </transition-group>
      <div class="picContent">
        <div
          v-for="(file, index) in fileList"
          class="mt10"
          style="
            width: 100px;
            height: 130px;
            margin-right: 30px;
            margin-bottom: 20px;
          "
          alt=""
          v-if="file.type == 'jpg' || file.type == 'png' || file.type == 'jpeg'"
        >
          <div style="width: 100px; height: 100px; border: 1px solid #eee">
            <!-- <img   :src="file.url" style="width:100px;height:100px" > -->
            <el-image v-if="file.url" style="width: 100px; height: 100px" :src="file.url" :preview-src-list="[file.url]" />
          </div>
          <div class="btnBox flex center" v-if="onlineAndOffline == 0">
            <!-- <el-button type="text" @click="handlePictureCardPreview(file)">查看</el-button> -->
            <!-- <el-link
              class="ml10"
              :href="`${file.url}`"
              :underline="false"
              target="_blank"
            > -->
            <el-button type="text" class="ml10" @click="uplod(index)" v-if="!disabled">下载</el-button>
            <!-- </el-link> -->
            <el-button type="text" class="ml10" @click="handleDelete(index)" v-if="!disabled">删除</el-button>
          </div>
          <div class="btnBox flex center" v-else>
            <!-- <el-button type="text" @click="handlePictureCardPreview(file)">查看</el-button> -->
            <el-link class="ml10" :href="`${file.url}`" :underline="false" target="_blank">
              <el-button type="text">下载</el-button>
            </el-link>
            <el-button type="text" class="ml10" @click="handleDelete(index)" v-if="!disabled">删除</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-button v-if="disabled && fileList == 0" size="mini"> 暂无数据</el-button>

    <el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
      <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
    </el-dialog>
  </div>
</template>

<script>
//   import { getToken } from "@/utils/auth";
import config from '@/utils/config';
export default {
  name: 'FileUpload',
  props: {
    btnText: {
      type: String,
      default: '选择文件',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    //
    fileUrl: {
      type: String,
    },
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 5,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ['doc', 'xls','xlsx', 'ppt', 'txt', 'pdf', 'png', 'jpeg', 'jpg'],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    //负载
    uploadData: {
      type: Object,
    },
  },
  data() {
    return {
      baseUrl: config.apiUrl,
      // uploadFileUrl: config.apiUrl + "/system/oss/upload", // 上传的图片服务器地址
      uploadFileUrl: config.apiUrl + this.onlineAndOffline == 0 ? '/common/upload' : '/system/oss/upload', // 上传的图片服务器地址
      headers: {
        Authorization: this.$local.get('token'),
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      fileName: '',
      onlineAndOffline: 0,
      loading:false
    };
  },
  created() {
    this.onlineAndOffline = JSON.parse(localStorage.getItem('userInfo')).isOnline; //0为离线（内网），1为在线（外网）
    // this.onlineAndOffline1=this.onlineAndOffline
    // console.log(this.onlineAndOffline1,11111111111);
    if (this.onlineAndOffline == 0) {
      if (this.fileUrl == '/oss/file/uploadFileFlag') {
        this.uploadFileUrl = this.baseUrl + '/common/upload';
        // log('11')
      }
      if (this.fileUrl == '/fireArchives/Archives/uploadFireOrganization') {
        this.uploadFileUrl = this.baseUrl + '/fireArchives/Archives/uploadFireOrganization';
      }
      console.log(this.uploadFileUrl, 'created');
    } else {
      console.log('在线');
      this.uploadFileUrl = this.baseUrl + this.fileUrl;
    }

    // this.uploadFileUrl = this.baseUrl + this.fileUrl;
    // this.uploadFileUrl = this.fileUrl;
  },
  watch: {
    fileUrl(val) {
      console.log(val, 'fileUrl');
      if (val) {
        if (this.onlineAndOffline == 0) {
          if (val == '/oss/file/uploadFileFlag') {
            this.uploadFileUrl = this.baseUrl + '/common/upload';
          }
          if (this.fileUrl == '/fireArchives/Archives/uploadFireOrganization') {
            this.uploadFileUrl = this.baseUrl + '/fireArchives/Archives/uploadFireOrganization';
          }
          // this.uploadFileUrl = this.baseUrl + val;
          // this.uploadFileUrl = val;
        } else {
          this.uploadFileUrl = this.baseUrl + val;
        }
      }
    },
    value: {
      handler(val) {
        if (val) {
          let temp = 1;
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map((item) => {
            if (typeof item === 'string') {
              var type = item.substr(item.lastIndexOf('.') + 1);
              //  alert()
              item = { name: item, url: item, type };
            }
            item.uid = item.uid || new Date().getTime() + temp++;
            return item;
          });
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    uplod(val) {
      // var str = url.substring(index + 1,url.length);
      // console.log(str)

      console.log(this.fileList, val, 'idnex');
      if (this.fileList[val].url.indexOf('png') > -1) {
        this.imageChangeUpload(val);
      } else if (this.fileList[val].url.indexOf('jpg') > -1) {
        this.imageChangeUpload(val);
      } else if (this.fileList[val].url.indexOf('dwg') > -1) {
        this.imageChangeUpload(val);
      } else {
        window.location.href = this.fileList[val].url;
      }
    },
    // 图片转换下载代码
    imageChangeUpload(val) {
      var url = this.fileList[val].name;
      var index = url.split('-');
      let imageName = index[1].split('.');
      console.log(imageName[0]);
      this.$get('/common/download/resource', {
        url: this.fileList[val].url,
      }).then((res) => {
        let base64Str = 'data:image/jpeg;base64,' + res;
        let aLink = document.createElement('a');
        aLink.style.display = 'none';
        aLink.href = base64Str;
        aLink.download = imageName[0];
        // 触发点击-然后移除
        document.body.appendChild(aLink);
        aLink.click();
        document.body.removeChild(aLink);
      });
    },
    handlePictureCardPreview(file) {
      console.log(file, 'file handlePictureCardPreview');
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;

    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      log(file, 'file上传前校检格式和大小');
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = '';
        if (file.name.lastIndexOf('.') > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          
          if (file.name.toLowerCase().indexOf(type) > -1) return true;

          if (fileExtension.toLowerCase() && fileExtension.toLowerCase().indexOf(type) > -1) return true;
          return false;
        });
        // console.log(isTypeOk,'isTypeOk');
        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`);
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      
      // return true;
      this.loading=true
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      this.loading=false
      this.$message.error('上传失败, 请重试');
    },
    // 上传成功回调
    handleUploadSuccess(res, file,fileList) {
      this.loading=false
      // const res = response.response
      // if(res===undefined)return
      if (this.onlineAndOffline == 0) {
        log(res, file, 'res file');
        this.fileName = file.name;
        // 原先
        this.$message({
                message: '上传成功',
                type: 'success',
                duration: 700,
              });
        // this.$message.success('上传成功');
        // this.fileList.push({ name: file.name, url: res.image_uuid });
        this.fileList.push({ name: res.data.fileName, url: res.data.url });
        this.$emit('input', this.listToString(this.fileList));
      } else {
        console.log(res.data,'成功');
        if (res.code === 200) {
          // this.$message({
          //       message: '上传成功',
          //       type: 'success',
          //       duration: 700,
          //     });
          // this.$message.success('上传成功');
          // console.log(fileList,'fileList');
          //  let ceshi=[]
          
          if (fileList.every(item => item.status == 'success')) {
              fileList.map(item => {
                // item.response&&this.fileList.push({name:item.name,url:item.response.data.url})
                /** 这时只需要push进带有response的数据就好 */
                if(item.response) {
                  console.log(33333);
                  this.fileList.push({
                    name: item.response.data.fileName,
                    url: item.response.data.url
                  })
          // console.log(this.fileList)
          this.$emit('input', this.listToString(this.fileList));

                }
              })
            }
          //   console.log(ceshi,'this.fileList')
                setTimeout(()=>{
              // this.uploadfile=false
              // this.icon={}
              // this.$refs.upload.clearFiles()
            },100)
          // console.log(11111111)

          // this.fileList.push({ name: res.data.fileName, url: res.data.url });
          // console.log(this.fileList)
          // this.$emit('input', this.listToString(this.fileList));
        } else {
          this.$message.error(res.msg);
          this.loading.close();
        }
      }

      // if (res.code === 200) {
      //   this.$message.success("上传成功");
      //   this.fileList.push({ name: res.data.fileName, url: res.data.url });
      //   this.$emit("input", this.listToString(this.fileList));
      // } else {
      //   this.$message.error(res.msg);
      //   this.loading.close();
      // }
    },
    // 删除文件
    handleDelete(index) {
      this.$emit('handleRemove');
      this.fileList.splice(index, 1);
      this.$emit('input', this.listToString(this.fileList));
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf('/') > -1) {
        return name.slice(name.lastIndexOf('/') + 1).toLowerCase();
      } else {
        return '';
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = '';
      separator = separator || ',';
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    },
  },
};
</script>

<style scoped lang="scss">
.picContent {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.upload-file-uploader {
  margin-bottom: 5px;
}
.upload-file-list .el-upload-list__item {
  border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
}
.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}
.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
::v-deep .el-icon-circle-close{
  color:red
}
</style>
